import { render, staticRenderFns } from "./DeleteStockOrderReferenceButtonActionModal.vue?vue&type=template&id=45490bf9&"
import script from "./DeleteStockOrderReferenceButtonActionModal.vue?vue&type=script&lang=js&"
export * from "./DeleteStockOrderReferenceButtonActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports